// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  display: flex;
  flex-direction: column;
  position: -webkit-sticky;
}

.compose__btn {
  padding: 10px 20px !important;
  border-radius: 16px !important;
  box-shadow: 2px 2px 3px #ccc;
  margin-top: 20px !important;
  margin-bottom: 20px !important;
  margin-left: 10px !important;
  max-width: 200px;
  background-color: rgb(125, 200, 227) !important;
  color: black !important;
  white-space: nowrap;
}
.Sidebarfolder {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 35px;
  width: 248px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  margin-bottom: 5px;
  padding-left: 19px;
  margin-right: 20px;
  position: relative;
  transition: background-color 0.3s;
  cursor: pointer;
}
/* .Sidebarfolder:hover {
  cursor: pointer;
  background-color: whitesmoke;
} */
.Sidebarfolder .end {
  display: flex;
}
/* .Sidebarfolder:active {
  background-color: #d3e3fd;
} */
/* .Sidebarfolder:hover {
  cursor: pointer;
  background-color: whitesmoke;
} */
.Sidebarfolder svg {
  color: rgb(64, 62, 66);
}

.Sidebarfolder p {
  font-size: 15px;
  font-weight: 5px;
  flex: 1 1;
  margin-left: 15px;
}
.Sidebarfolder .middle {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
}

.Sidebarfolder .arrow svg {
  font-size: 22px;
}
.Sidebarfolder .setting {
  background-color: #d3e3fd;
  position: absolute;
  left: 235px;
  top: 20px;
  z-index: 1;
  border-radius: 5px;
}
.foldersettings {
  width: 180px;
}
.foldersettings .selects {
  margin: 5px auto;
  border: 0;
  border-radius: 2px;
  display: flex;
  align-items: center;
  width: 150px;
}
.foldersettings .btnselect {
  margin: 5px auto;
  display: flex;
  align-items: center;
  width: 150px;
}
/* .side_bar .Sidebarfolder:active{
  background-color: #0FC6EE;
} */
.Sidebarfolder--active {
  background-color:#0fc6ee !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/NewCreateCollection/features/css/sidebar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,+CAA+C;EAC/C,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;AACjB;AACA;;;GAGG;AACH;EACE,aAAa;AACf;AACA;;GAEG;AACH;;;GAGG;AACH;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;;GAEG;AACH;EACE,mCAAmC;AACrC","sourcesContent":[".sidebar {\n  display: flex;\n  flex-direction: column;\n  position: -webkit-sticky;\n}\n\n.compose__btn {\n  padding: 10px 20px !important;\n  border-radius: 16px !important;\n  box-shadow: 2px 2px 3px #ccc;\n  margin-top: 20px !important;\n  margin-bottom: 20px !important;\n  margin-left: 10px !important;\n  max-width: 200px;\n  background-color: rgb(125, 200, 227) !important;\n  color: black !important;\n  white-space: nowrap;\n}\n.Sidebarfolder {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 35px;\n  width: 248px;\n  border-top-right-radius: 20px;\n  border-bottom-right-radius: 20px;\n  margin-bottom: 5px;\n  padding-left: 19px;\n  margin-right: 20px;\n  position: relative;\n  transition: background-color 0.3s;\n  cursor: pointer;\n}\n/* .Sidebarfolder:hover {\n  cursor: pointer;\n  background-color: whitesmoke;\n} */\n.Sidebarfolder .end {\n  display: flex;\n}\n/* .Sidebarfolder:active {\n  background-color: #d3e3fd;\n} */\n/* .Sidebarfolder:hover {\n  cursor: pointer;\n  background-color: whitesmoke;\n} */\n.Sidebarfolder svg {\n  color: rgb(64, 62, 66);\n}\n\n.Sidebarfolder p {\n  font-size: 15px;\n  font-weight: 5px;\n  flex: 1;\n  margin-left: 15px;\n}\n.Sidebarfolder .middle {\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  align-items: center;\n}\n\n.Sidebarfolder .arrow svg {\n  font-size: 22px;\n}\n.Sidebarfolder .setting {\n  background-color: #d3e3fd;\n  position: absolute;\n  left: 235px;\n  top: 20px;\n  z-index: 1;\n  border-radius: 5px;\n}\n.foldersettings {\n  width: 180px;\n}\n.foldersettings .selects {\n  margin: 5px auto;\n  border: 0;\n  border-radius: 2px;\n  display: flex;\n  align-items: center;\n  width: 150px;\n}\n.foldersettings .btnselect {\n  margin: 5px auto;\n  display: flex;\n  align-items: center;\n  width: 150px;\n}\n/* .side_bar .Sidebarfolder:active{\n  background-color: #0FC6EE;\n} */\n.Sidebarfolder--active {\n  background-color:#0fc6ee !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
